import React, { Component } from 'react';
import { reasonModel } from '../../../api';
import { EmptyState } from '../../commons';
import { InvalidSearchImg, defaultIssueImg } from '../../../images/images';
import './ReportIssue.scss';
import { issues1 as issues, issuesSlug } from '../../../constants/reasons';
import { StatusView } from './Issues/common';
import getStore from '../../../store/store';
import {
  setIssueSubmission,
  getOrderBasicInfo,
} from '../../../store/basicOrder/actions';
import { OrderSpilled } from './Issues';
import { Modal } from '../../../UiKit';
import '../../serverDrivenUIComponents/serverDrivenUICss.css';
import '../../../UiKit/uploadImage/uploadImage.scss';
import { Repeat, Play } from 'sushiweb/Icons';
import { green, grey } from 'sushiweb/tokens/color';
import { ComplaintMediaComp, UploadMediaComp } from './ComplaintMediaComp';
import { mediaTypes, mediaValidationSlugs } from './ComplaintMediaComp';
import PendingIssues from './Issues/PendingIssues/PendingIssues';
import { AddonAction } from './Issues/common/AddonAction/AddonAction';
import {
  RefreshMediaClickEvent,
  ViewAndUploadModalClickEvent,
} from '../../../analytics/raise-an-issue/events';
import { RfoSubmitCtaClickedEvent } from '../../../analytics/rfo/events';
import {
  MetricsForJumboEvent,
  RFO_CACR_REASON_ID,
} from '../../../analytics/constants';
import { Skeleton } from '../../ComponentsV1/Skeleton/Skeleton';

const showThumbNail = (countToShow, items) => {
  const count = items?.length;
  if (!items) return null;
  const itemsToShow = items.slice(0, countToShow);
  return itemsToShow.map((item, ind) => {
    return (
      <span
        className='tw-rounded-lg tw-bg-base-white tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-text-grey-500 tw-text-200 tw-font-medium'
        role='img'
        aria-label='item'
        key={ind}
      >
        {ind === countToShow - 1 && countToShow != count ? (
          `+${count - (countToShow - 1)}`
        ) : item?.media_type === mediaTypes['image'] ? (
          <img
            src={item?.media_url}
            alt='item'
            width='100%'
            height='100%'
            className='tw-rounded-lg'
          />
        ) : (
          <Play size={12} color={grey.z700} />
        )}
      </span>
    );
  });
};

const MediaModalTitleComp = ({
  getComplaintImages,
  orderId,
  userId,
  cartId,
  complaintType = null,
}) => {
  const refreshHandler = () => {
    RefreshMediaClickEvent({
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.feature_meta]: {
        complaint_type: complaintType,
      },
    });
    getComplaintImages(orderId);
  };

  return (
    <div className='tw-flex tw-w-full tw-justify-between tw-items-center'>
      <div className='tw-flex tw-justify-between tw-w-full'>
        <div className='tw-flex-col tw-text-500 tw-font-extrabold'>
          Complaint Images/Videos
        </div>
        <div className='tw-flex tw-gap-5 tw-text-green-700 tw-mr-3 '>
          <div
            className='tw-py-2 tw-px-4 tw-rounded-xl tw-border tw-border-solid  tw-border-grey-300  tw-text-200 tw-font-semibold tw-cursor-pointer tw-flex tw-gap-1'
            onClick={refreshHandler}
          >
            <Repeat size={13} color={green.z700} />
            <span className='tw-text-200 tw-ml-2'>Refresh</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default class ReportIssue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reasons: null,
      selectedDropdownVal: '',
      issueInfo: this.props.list,
      isFormSubmit: false,
      formSubmitRes: null,
      error: false,
      errorImg: defaultIssueImg,
      selectedGroupedReason: null,
      selectedGroupedReasonId: null,
      isGrouped: false,
      errorHeading: 'Everything looks fine',
      errorSubHeading:
        'If something goes wrong, use this panel for all the help needed',
      isDisabled: false,
      showComplaintImages: true,
      showPopUp: false,
      approvedMedia: [],
      availableComplaintImages: [],
      mediaRrefetching: false,
      sessionId: null,
      isUploadEnabled: false,
    };
    this.timerId1 = null;
    this.timerId2 = null;
  }
  componentWillUnmount = () => {
    clearTimeout(this.timerId1);
    clearTimeout(this.timerId2);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.isUploadEnabled != this.state.isUploadEnabled &&
      this.state.isUploadEnabled &&
      !this.state.availableComplaintImages?.length
    ) {
      this.setState({
        mediaRrefetching: true,
      });
      this.getComplaintImages(this.props.orderId);
    }
    if (prevProps.resetSmartplugState !== this.props.resetSmartplugState) {
      this.setState({
        selectedDropdownVal: '',
        issueInfo: null,
        isFormSubmit: false,
        formSubmitRes: null,
        error: false,
        isGrouped: false,
        selectedGroupedReason: null,
        selectedGroupedReasonId: null,
        creditOptions: null,
      });
    }
  };

  getComplaintImages = (orderId = null) => {
    this.setState({
      mediaRrefetching: true,
    });
    return reasonModel
      .getComplaintImages(orderId, this.state.session_id)
      .then((response) => {
        this.setState({
          mediaRrefetching: false,
        });
        if (!response || (response && response.isError === true)) return null;
        this.setState({
          availableComplaintImages: response.complaint_media,
          sessionId: response.session_id,
        });
        this.updateApprovedMedia(null, null, response.complaint_media);
      })
      .catch(() => {
        this.setState({
          mediaRrefetching: false,
        });
      });
  };

  deleteComplaintImages = (
    mediaId = null,
    setConfirmDelete,
    indexOfDeletedImg,
  ) => {
    const { availableComplaintImages } = this.state;
    return reasonModel
      .deleteComplaintImages(mediaId)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        if (response.success)
          setConfirmDelete({
            isDeleting: false,
            mediaId: mediaId,
            success: true,
            index: indexOfDeletedImg,
          });
        this.updateApprovedMedia(mediaId, 'delete');

        const updateImgs = [];
        for (let i = 0; i < availableComplaintImages.length; i++) {
          if (availableComplaintImages[i]?.media_id != mediaId)
            updateImgs.push(availableComplaintImages[i]);
        }
        this.setState({
          availableComplaintImages: updateImgs,
        });
      })
      .catch(() => {
        setConfirmDelete({
          isDeleting: false,
        });
      });
  };

  tryAgain = (value, url, isGrouped) => {
    const { orderId } = this.props;
    let data = {};
    data['order_id'] = orderId;
    if (url) {
      this.sendFormData(url, value, data, isGrouped);
    } else {
      this.getIssuesInfo(value, url);
    }
  };

  getMacStatus = () => {
    const { orderId, selectedValue, goBack } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    return reasonModel
      .getMacResponse(selectedValue, queryStrings)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        this.setState({
          issueInfo: response,
          formSubmitRes: null,
          isFormSubmit: false,
          error: false,
        });
      })
      .catch((err) => {
        console.log('get Mac Status error');
      });
  };

  handleIssueImageModal = () => {
    const { orderId, cartId, userId } = this.props;

    // logging the event only when the modal is not already open
    if (!this.state.showPopUp) {
      ViewAndUploadModalClickEvent({
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.cart_id]: cartId,
        [MetricsForJumboEvent.customer_id]: userId,
        [MetricsForJumboEvent.feature_meta]: {
          complaint_type: this.props?.complaintType,
        },
      });
    }

    this.setState({
      showPopUp: !this.state.showPopUp,
    });
  };

  handleComplaintImgvisibilty = () => {
    this.setState({
      showComplaintImages: !this.state.showComplaintImages,
    });
  };

  updateImageGrid = (data) => {
    const newImageSet = [...this.state.availableComplaintImages, ...data];
    const uploadedMediaIds = [];
    for (let i = 0; i < data.length; i++) {
      uploadedMediaIds.push(data[i].media_id);
    }
    this.setState({
      availableComplaintImages: newImageSet,
      approvedMedia: [...this.state.approvedMedia, ...uploadedMediaIds],
    });
  };

  handleImageEnable = (value) => {
    this.setState({
      isUploadEnabled: value,
    });
  };

  renderIssues = () => {
    const {
      issueInfo,
      isFormSubmit,
      formSubmitRes,
      creditOptions,
      isDisabled,
      showPopUp,
      approvedMedia,
      showComplaintImages,
      availableComplaintImages,
      mediaRrefetching,
      sessionId,
      isUploadEnabled,
    } = this.state;

    const {
      orderId,
      userId,
      cartId,
      complaintType,
      handleCardLink = () => {},
      selectedValue,
      isResolutionService,
      goBack = () => {},
      mediaValidation,
      skipItemSelectionScreen = false,
      preSelectedItems = [],
      complaintId = null,
      orderLevelPayload = {},
    } = this.props;

    if (isFormSubmit && formSubmitRes) {
      let statusViewImgStyle = formSubmitRes.autoresolve_timestamp
        ? '30vh'
        : '10vh';

      return (
        <div className='formSubmitResContainer'>
          {formSubmitRes?.has_more_action ? (
            <AddonAction
              addOnActions={formSubmitRes}
              reasonId={selectedValue}
              orderId={orderId}
              isDisabled={isDisabled}
              handleCardLink={handleCardLink}
            />
          ) : (
            <StatusView
              response={formSubmitRes}
              tryAgain={this.tryAgain.bind(this, selectedValue)}
              imgHeight={statusViewImgStyle}
              imgWidth={statusViewImgStyle}
              everyMinuteHandler={this.getMacStatus}
            />
          )}
        </div>
      );
    } else {
      if (!issueInfo && !isResolutionService) return null;
      let CompName = OrderSpilled;
      if (skipItemSelectionScreen) {
        CompName = PendingIssues;
      } else if (selectedValue in issues) {
        CompName = issues[selectedValue];
      } else if (selectedValue in issuesSlug) {
        CompName = issuesSlug[selectedValue];
      }

      if (!issueInfo && !skipItemSelectionScreen) return null;

      return (
        <>
          {mediaValidation &&
            mediaValidation != mediaValidationSlugs.not_applicable &&
            showComplaintImages &&
            (mediaRrefetching ? (
              <div className='tw-rounded-lg tw-justify-between tw-mx-7 tw-mt-6 tw-items-center'>
                <Skeleton rows={[{ cols: 1, height: '4.6rem' }]} />
              </div>
            ) : (
              <div
                className={`tw-p-5 tw-rounded-lg tw-justify-between  tw-mx-8 tw-mt-6 tw-items-center ${
                  availableComplaintImages?.length
                    ? 'tw-bg-red-100 '
                    : 'tw-bg-grey-100'
                }`}
              >
                <div
                  className={` ${
                    availableComplaintImages?.length
                      ? 'tw-flex-col tw-items-start tw-justify-center tw-gap-2'
                      : 'tw-w-full tw-flex tw-items-center tw-justify-between'
                  }`}
                >
                  <span className='tw-font-semibold tw-text-300'>
                    Complaint Images
                  </span>
                  <span className='tw-text-green-700 tw-text-100 tw-font-regular '>
                    <UploadMediaComp
                      updateImageGrid={this.updateImageGrid}
                      textToShow={
                        availableComplaintImages?.length
                          ? 'View & Upload'
                          : 'Upload'
                      }
                      textStyle='tw-text-100 tw-font-medium'
                      orderId={orderId}
                      userId={userId}
                      cartId={cartId}
                      sessionId={sessionId}
                      isUploadEnabled={isUploadEnabled}
                      isInputDisabled={availableComplaintImages?.length}
                      onClick={
                        availableComplaintImages?.length && isUploadEnabled
                          ? this.handleIssueImageModal
                          : () => {}
                      }
                      keyVal='3'
                      complaintType={complaintType}
                    />
                  </span>
                </div>
                <div className='tw-flex tw-gap-3'>
                  {showThumbNail(3, availableComplaintImages)}
                </div>
              </div>
            ))}

          <CompName
            issueInfo={issueInfo}
            orderId={orderId}
            cartId={cartId}
            userId={userId}
            complaintType={complaintType}
            complaintId={complaintId}
            reasonId={selectedValue}
            isFormSubmit={isFormSubmit}
            formSubmitRes={formSubmitRes}
            sendFormData={this.sendFormData}
            getCreditOptions={this.getCreditOptions}
            creditOptions={creditOptions}
            isDisabled={isDisabled}
            tryAgain={this.tryAgain.bind(this, selectedValue)}
            everyMinuteHandler={this.getMacStatus}
            handleCardLink={handleCardLink}
            isResolutionService={isResolutionService}
            goBack={goBack}
            handleComplaintImgvisibilty={this.handleComplaintImgvisibilty}
            mandateImageCheck={
              mediaValidation === 'MANDATORY' ? approvedMedia?.length : true
            }
            mediaValidation={mediaValidation}
            handleImageEnable={this.handleImageEnable}
            approvedMedia={approvedMedia}
            availableComplaintImages={availableComplaintImages}
            isMediaRefetching={mediaRrefetching}
            preSelectedItems={preSelectedItems}
            orderLevelPayload={orderLevelPayload}
          />

          {showPopUp && (
            <Modal
              isMaxContent
              type='large'
              isVisible={showPopUp}
              titleComponent={
                <MediaModalTitleComp
                  approvedMedia={approvedMedia}
                  availableComplaintImages={availableComplaintImages}
                  getComplaintImages={this.getComplaintImages}
                  orderId={orderId}
                  userId={userId}
                  cartId={cartId}
                  sessionId={sessionId}
                  complaintType={complaintType}
                />
              }
              maxHeight='70vh'
              minHeight='50vh'
              handleClose={this.handleIssueImageModal}
              showScrollBar={false}
              paddingTop='17px'
              component={
                <ComplaintMediaComp
                  availableComplaintImages={availableComplaintImages}
                  handleIssueImageModal={this.handleIssueImageModal}
                  updateImageGrid={this.updateImageGrid}
                  orderId={orderId}
                  userId={userId}
                  cartId={cartId}
                  sessionId={sessionId}
                  isUploadEnabled={isUploadEnabled}
                  deleteComplaintImages={this.deleteComplaintImages}
                  mediaRrefetching={mediaRrefetching}
                  updateApprovedMedia={this.updateApprovedMedia}
                  complaintType={complaintType}
                />
              }
            />
          )}
        </>
      );
    }
  };

  checkIfValidUrl = (url) => {
    if (!url) {
      this.setState({
        issueInfo: null,
        error: true,
        errorImg: InvalidSearchImg,
        errorHeading: 'Oooopss Something went wrong!',
        errorSubHeading: 'Please try again!',
      });
      return false;
    }
    return true;
  };

  setErrorState = (response) => {
    this.setState({
      issueInfo: null,
      error: true,
      errorImg: InvalidSearchImg,
      errorHeading: response.message,
      errorSubHeading: '',
    });
  };

  getCreditOptions = (url, reasonId, data) => {
    if (url === 'isResolutionService') {
      this.setState({
        creditOptions: true,
      });
    }

    this.checkIfValidUrl(url);
    this.setState({
      creditOptions: null,
      isDisabled: false,
    });

    return reasonModel.sendFormData(url, reasonId, data).then((response) => {
      if (!response) return null;

      if (response && response.isError === true) {
        this.setErrorState(response);
      } else {
        this.setState({
          isFormSubmit: true,
          creditOptions: response,
          error: false,
        });
      }
      return response;
    });
  };

  reloadLeftWidget = () => {
    const { orderId, resetSmartplugState } = this.props;
    let obj = {
      orderId: orderId,
      hasSubmission: true,
    };
    getStore().dispatch(setIssueSubmission(obj));
    if (!resetSmartplugState) {
      this.timerId1 = setTimeout(() => {
        getStore().dispatch(getOrderBasicInfo(orderId));
        getStore().dispatch(setIssueSubmission(null));
      }, 500);
    }
  };

  sendFormData = (url, reasonId, data, isGrouped) => {
    this.checkIfValidUrl(url);
    this.setState({
      isDisabled: true,
    });

    const { orderId, cartId, userId } = this.props;
    const isRfoCacrFlow = Number(reasonId) === RFO_CACR_REASON_ID;

    return reasonModel
      .sendFormData(url, reasonId, data)
      .then((response) => {
        if (isRfoCacrFlow) {
          RfoSubmitCtaClickedEvent({
            [MetricsForJumboEvent.order_id]: orderId,
            [MetricsForJumboEvent.cart_id]: cartId,
            [MetricsForJumboEvent.customer_id]: userId,
            [MetricsForJumboEvent.feature_meta]: {
              url,
              request: JSON.stringify(data),
              success: !(response && response.isError === true),
              response: JSON.stringify(response),
            },
          });
        }

        if (!response) return null;

        if (response && response.isError === true) {
          this.setErrorState(response);
        } else {
          this.setState({
            isFormSubmit: !isGrouped ? true : false,
            formSubmitRes: !isGrouped ? response : null,
            issueInfo: isGrouped ? response : null,
            error: false,
          });
          this.timerId2 = setTimeout(() => {
            this.reloadLeftWidget();
          }, 500);
        }
        this.setState({
          isDisabled: false,
        });
        return response;
      })
      .catch((err) => {
        if (isRfoCacrFlow) {
          RfoSubmitCtaClickedEvent({
            [MetricsForJumboEvent.order_id]: orderId,
            [MetricsForJumboEvent.cart_id]: cartId,
            [MetricsForJumboEvent.customer_id]: userId,
            [MetricsForJumboEvent.feature_meta]: {
              url,
              request: JSON.stringify(data),
              success: false,
              error: err?.message,
            },
          });
        }
        this.setState({
          issueInfo: null,
          isDisabled: false,
          error: true,
          errorImg: InvalidSearchImg,
          errorHeading: err?.message || 'Oooopss Something went wrong!',
          errorSubHeading: 'Please try again!',
        });
      });
  };

  updateApprovedMedia = (id, action = null, approvedMedias) => {
    const { approvedMedia } = this.state;

    let updatedMedia = [];

    if (action === 'add') updatedMedia.push(id);
    else if (action === 'delete') {
      const ind = approvedMedia.indexOf(id);
      approvedMedia.splice(ind, 1);
      updatedMedia = approvedMedia;
    } else {
      for (let i = 0; i < approvedMedias.length; i++) {
        updatedMedia.push(approvedMedias[i]?.media_id);
      }
    }

    this.setState({
      approvedMedia: updatedMedia,
    });
  };

  render() {
    const { selectedValue } = this.props;
    const { error, errorImg, errorHeading, errorSubHeading } = this.state;
    return (
      <div className='reportIssueContainer'>
        {!selectedValue || error ? (
          <EmptyState
            img={errorImg}
            isPop={true}
            heading={errorHeading}
            subHeading={errorSubHeading}
          />
        ) : (
          <React.Fragment>{this.renderIssues(selectedValue)}</React.Fragment>
        )}
      </div>
    );
  }
}
